import React, { useEffect } from 'react';
import Services from './services/Services';
import Hero from './Hero/Hero';
import WhyUs from './whyUs/WhyUs';
import Testimonials from './testimonials/Testimonials';
import VideoSection from './videoSection/VideoSection';
import { Helmet } from 'react-helmet';
import BookAppoinment from './bookAppoinment/BookAppoinment';
import BottomtoTop from '../components/BottomtoTop/BottomtoTop';

const PageIndex = () => {
    
    return (
        <div>
            <Helmet>
                <title>PG Overseas Services | Global Migration, Investment & Business Consulting</title>
                <meta
                    name="description"
                    content="PG Overseas Services is your trusted partner for global migration, import/export, investment, business setup, real estate, and relocation solutions across borders."
                />
                <meta
                    name="keywords"
                    content="PG Overseas Services, global migration consultants, import export solutions, business relocation India, investment residency services, NRI property management, international business advisory"
                />
            </Helmet>

            <Hero />
            <WhyUs />
            <section id="service">
                <Services />
            </section>
            <Testimonials />
            <VideoSection />
            <BookAppoinment/>
            <BottomtoTop/>
        </div>
    );
};

export default PageIndex;
